const numbers = [ 'ноль', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять' ]

exports.numbersToText = value => {
  const match = value.match(/\d+/g)
  if (!match) {
    return value
  }

  const result = []
  for (const item of match) {
    const length = item.length
    const start = value.indexOf(item)
    const end = start + length
    const replace = []

    if (length) {
      for (const digit of item.split('')) {
        replace.push(numbers[Number(digit)])
      }
    }

    result.push({
      start,
      end,
      value: replace.join(' ')
    })
  }

  return result
    .reverse()
    .reduce((acc, item) => {
      const start = acc.slice(0, item.start)
      const end = acc.slice(item.end)

      return start + item.value + end
    }, value)
}
